import React, { Component } from 'react';

import WorkComponent from './WorkComponent.js';

class LocationContent extends Component {



	render() {
		let WorkComponentContainer;
		if(this.props.workComponent===true) {

		  WorkComponentContainer =  <WorkComponent 
		  							handleWorkContent = {this.props.handleWorkContent}/>
		}

		return(
			<div className="LocationContent" >
				{ WorkComponentContainer }
			</div>
		)
	}

}

export default LocationContent;


// WEBPACK FOOTER //
// ./src/components/LocationContent.js